/* This file was generated by running "node scripts/generateTranslations.js". */
/* Created: 2025-04-08 20:58:06 */

const Keys = {
  traveler: 'traveler',
  info: 'info',
  child: 'child',
  adult: 'adult',
  infant: 'infant',
  ssr: 'ssr',
  seats: 'seats',
  notes: 'notes',
  subItemType_HOTEL: 'subItemType_HOTEL',
  subItemType_TOUR: 'subItemType_TOUR',
  subItemType_FLIGHT: 'subItemType_FLIGHT',
  subItemType_EXTRA: 'subItemType_EXTRA',
  subItemType_CHAUFFEURED_SERVICE: 'subItemType_CHAUFFEURED_SERVICE',
  subItemType_TRANSFER: 'subItemType_TRANSFER',
  subItemType_AIRPORT_TRANSFER: 'subItemType_AIRPORT_TRANSFER',
  subItemType_DINING: 'subItemType_DINING',
  subItemType_LOUNGE_ACCESS: 'subItemType_LOUNGE_ACCESS',
  subItemType_MEET_AND_GREET: 'subItemType_MEET_AND_GREET',
  subItemType_PACKAGE: 'subItemType_PACKAGE'
}; export default Keys;